// test2102
(2102 && 0);
